module.exports = {
      id: "twittericon-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-cba8a2d7d36c4565ac7b4e175a8fc907.svg#twittericon",
      toString: function () {
        return this.url;
      }
    }